<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5 class="mb-0">{{ title }}</h5>
      <div>
        <b-badge v-if="drillPath.length" variant="light" class="mr-2">
          <span v-for="(p, i) in drillPath" :key="i">
            <b-link @click="popTo(i)">{{ p.label }}</b-link>
            <span v-if="i < drillPath.length - 1"> › </span>
          </span>
          <b-link class="ml-2 text-danger" @click="resetDrill">✕</b-link>
        </b-badge>
        <b-button v-if="exportable" size="sm" variant="outline-success" @click="$emit('export')">
          Exportar Excel
        </b-button>
      </div>
    </div>

    <b-table
      striped
      hover
      responsive
      small
      show-empty
      :busy="busy"
      :items="rows"
      :fields="computedFields"
      empty-text="Sin datos para los filtros seleccionados."
    >
      <template #table-busy>
        <div class="text-center text-primary my-3">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Cargando…</strong>
        </div>
      </template>
      <template v-if="drillable" #cell(_drill)="data">
        <b-button size="sm" variant="outline-primary" @click="onDrill(data.item)">›</b-button>
      </template>
    </b-table>

    <b-pagination
      v-if="total > perPage"
      :value="page"
      :total-rows="total"
      :per-page="perPage"
      align="center"
      @input="$emit('page', $event)"
    ></b-pagination>
  </div>
</template>

<script>
// Tabla paginada de un reporte ejecutivo (doc 04 §3). Deriva columnas de las filas,
// soporta drill-down (periodo → canal → sucursal → cliente → ticket) y exporta a Excel
// vía el backend (excelize). Es presentacional: el padre resuelve los datos.
export default {
  name: 'DrillTable',
  props: {
    title: { type: String, default: 'Detalle' },
    rows: { type: Array, default: () => [] },
    fields: { type: Array, default: null }, // opcional; si no, se derivan de las filas
    busy: { type: Boolean, default: false },
    total: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 50 },
    drillable: { type: Boolean, default: false },
    exportable: { type: Boolean, default: true },
    drillPath: { type: Array, default: () => [] }
  },
  computed: {
    computedFields() {
      let base;
      if (this.fields && this.fields.length) {
        base = this.fields.slice();
      } else if (this.rows.length) {
        base = Object.keys(this.rows[0]).map((k) => ({
          key: k,
          label: this.humanize(k),
          sortable: true
        }));
      } else {
        base = [];
      }
      if (this.drillable) base.push({ key: '_drill', label: '' });
      return base;
    }
  },
  methods: {
    humanize(k) {
      return k.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    },
    onDrill(item) {
      this.$emit('drill', item);
    },
    popTo(i) {
      this.$emit('drill-pop', i);
    },
    resetDrill() {
      this.$emit('drill-reset');
    }
  }
}
</script>
